import {
  collection,
  addDoc,
  updateDoc,
  doc,
  deleteDoc,
  getDocs,
  query,
  where,
  onSnapshot,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';

export const notificationService = {
  async createNotification(notification) {
    try {
      await addDoc(collection(db, 'notifications'), {
        ...notification,
        createdAt: serverTimestamp(),
        read: false,
      });
    } catch (error) {
      console.error('Failed to create notification:', error);
    }
  },

  subscribeToUnreadCount(userId, callback) {
    try {
      const q = query(
        collection(db, 'notifications'),
        where('recipientId', '==', userId),
        where('read', '==', false)
      );
      return onSnapshot(q, (snap) => callback(snap.size), () => callback(0));
    } catch (error) {
      console.error('Failed to subscribe to unread count:', error);
      callback(0);
      return () => {};
    }
  },

  subscribeToRecent(userId, callback, max = 20) {
    try {
      // Avoid composite index requirement by not using orderBy here.
      const q = query(
        collection(db, 'notifications'),
        where('recipientId', '==', userId)
      );
      return onSnapshot(
        q,
        (snap) => {
          const items = snap.docs
            .map((d) => ({ id: d.id, ...d.data() }))
            .sort((a, b) => {
              const ad = a.createdAt?.toDate?.() || new Date(a.createdAt || 0);
              const bd = b.createdAt?.toDate?.() || new Date(b.createdAt || 0);
              return bd - ad;
            })
            .slice(0, max);
          callback(items);
        },
        (err) => {
          console.error('Recent notifications subscription error:', err);
          callback([]);
        }
      );
    } catch (error) {
      console.error('Failed to subscribe to recent notifications:', error);
      callback([]);
      return () => {};
    }
  },

  async markAllAsRead(userId) {
    try {
      const q = query(
        collection(db, 'notifications'),
        where('recipientId', '==', userId),
        where('read', '==', false)
      );
      const snap = await getDocs(q);
      await Promise.all(
        snap.docs.map((d) => updateDoc(doc(db, 'notifications', d.id), { read: true }))
      );
    } catch (error) {
      console.error('Failed to mark notifications read:', error);
    }
  },

  async markAsRead(notificationId) {
    try {
      await updateDoc(doc(db, 'notifications', notificationId), { read: true });
    } catch (error) {
      console.error('Failed to mark notification read:', error);
    }
  },

  async deleteNotification(notificationId) {
    try {
      await deleteDoc(doc(db, 'notifications', notificationId));
    } catch (error) {
      console.error('Failed to delete notification:', error);
    }
  },
};


